import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Moment from 'react-moment';
import Table from '../../../../../../components/table/Table';

export default class PlateTransfer extends Component {
    render() {
        let history = this.props.details.history;

        if (this.props.details.has_transfered_plate) {
            return (
                <Row>
                    <Col md="12">
                        {Array.isArray(history) && history.length > 0 ?
                            <Table responsive className="table--bordered hpi">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Current VRM</th>
                                        <th>Previous VRM</th>
                                        <th>Transaction Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((el, i) => (
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td>{el.current_vrm}</td>
                                            <td>{el.previous_vrm}</td>
                                            <td>
                                                {el.date_of_transaction ?
                                                    <Moment format="D MMM YYYY">
                                                        {el.date_of_transaction}
                                                    </Moment>
                                                    : '-'
                                                }  
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            :
                            <p>There is a plate transfer recorded</p>
                        }
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about any plate transfers</p></Col></Row>);
    }
}

PlateTransfer.propTypes = {
    details: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/plateTransfer.js